<template>
  <div>
    <div>
      <nav class="tab">
        <div class="btn_wrap">
          <button class="on">휴대폰번호 변경하기</button>
        </div>
      </nav>
      <main class="main" role="main">
        <div class="page btm t grey" style="height: 100vh"><!-- '하단 버튼: btm', '탭: t', '로그인, 아이디찾기, 비밀번호찾기: grey'-->
          <div class="inner">
            <div class="page_con">
              <div class="find_id w420">
                <div class="form">
                  <!-- 홈페이지 유지보수 개발요청안 | 휴면해제 기능 추가 (서남아이에스 임현아, 2024-07-03)   -->
                  <modal-alert-confirm-info
                    v-bind:isShowAlert="isShowTimeCheckConfirm"
                    v-bind:data="popupData"
                    v-bind:call-back="fnAlertConfirm"
                    v-bind:cancel-call-back="fnAlertCancel" />
                  <ul class="form_ul">
                    <!-- <li class="form_li">
                      <div class="form_ttl">
                        <p>이름</p>
                      </div>
                      <div class="form_in">
                        <div class="input">
                          <input type="text" placeholder="이름을 입력해 주세요" v-model="form.name">
                          <p class="valid" :class="{ 'on': $v.form.name.$error }">이름을 입력해주세요.</p>
                        </div>
                      </div>
                    </li> -->
                    <li class="form_li">
                      <div class="form_ttl">
                        <p>변경된 휴대폰 번호</p>
                      </div>
                      <div class="form_in">
                        <div class="input">
                          <input type="text" placeholder="-를 제외하고 입력해 주세요" v-model="form.userPhone" id="userPhone"
                            maxlength="11" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                            inputmode="decimal" pattern="[0-9]*">
                        </div>
                        <p class="valid" :class="{ 'on': $v.form.userPhone.$error }">{{ msg.userPhone }}</p>
                        <!--'on 추가'-->
                        <button class="btn bo" @click="fnAuth">{{ msg.send }}</button>
                        <div class="inline time_count">
                          <div class="input">
                            <input type="number" v-model="form.authNumber" id="authNumber">
                            <span class="time" id="time" v-show="form.isRunning">{{ form.count }}</span>
                          </div>
                          <button class="btn bo grey" disabled @click="fnConfirmAuth" id="block">인증하기</button>
                        </div>
                        <p class="valid">유효성 문구 영역</p><!--'on 추가'-->
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="page_btn">
                  <button class="btn" @click="fnChangePhone">변경하기</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import ModalAlertConfirmInfo from '@/components/common/alert/ConfirmInfo';

export default {
  name: 'user-page-phone-index',
  components: {ModalAlertConfirmInfo},
  data: function () {
    return {
      form: {
        userNo: -1,
        email: '',
        userId: '',
        name: '',
        checkName: '',
        userPhone: '',
        oldUserPhone: '',
        changePhone: '',
        authNumber: '', // 인증번호
        authConfirmNumber: '', // 발송된 인증번호,
        isAuth: false,  // 인증번호 인증여부
        isRunning: false, // 타이머 작동 여부,
        count: '03:00',
        timeCounter: 180 // 3분
      },
      msg: {
        send: '인증번호 발송',
        userPhone: ''
      },
      isShowTimeCheckConfirm: false,
      popupData: {}
    }
  },
  validations: {
    form: {
      // name: {
      //   required
      // },
      userPhone: {
        test: function (val) {
          if (this.$Util.isEmpty(val)) {
            this.msg.userPhone = '휴대폰 번호를 입력해주세요.'
            return false
          }
          return required(val)
        }
      }
    }
  },
  methods: {
    fnChangePhone: function () {      
      if (!this.$Util.isValid(this.$v, this.$el)) return false
      const params = {}
      params.userId = this.form.userId
      params.name = this.form.name
      params.userPhone = this.form.userPhone
      if (this.form.isAuth === false) {
        alert('휴대폰인증을 해주세요')
        return false
      }
      //휴면해제하기 API
      // 홈페이지 유지보수 개발요청안 | 비회원 대상 Alert 추가 (서남아이에스 임현아, 2024-07-02)      
      this.isShowTimeCheckConfirm = true
      this.popupData.content = `입력하신 휴대폰번호로 변경하시겠습니까?`
    },
    fnAlertConfirm: function(){
      const params = {}
      params.userPhone = this.form.userPhone

      console.log(params)

      this.$UserSvc.updateUserPhone(params).then(res => {
        // 팝업 닫기
        this.isShowTimeCheckConfirm = false

        if (res.code === 1) {
          alert('휴대폰번호가 정상적으로 변경되었습니다.\n다시 로그인이 필요합니다.')
          const params = {}
          params.applicationId = 'edu'
          this.$UserSvc.logout(params).then(res => {
            if(res.code === 1) {
              this.$router.push({path: '/main'})
            }
          })
        } else {
          alert(res.message)
        }
      })
    },
    fnAlertCancel: function(){
      // 팝업 닫기
      this.isShowTimeCheckConfirm = false
      this.$router.go(-1)
    },
    fnAuth: function () {
      if (!this.$Util.isValid(this.$v, this.$el)) return false

      const params = {}
      params.userNo = -1
      params.userId = this.form.userId
      params.name = this.form.name
      params.userPhone = this.form.userPhone

      this.$AuthSvc.sendForPhoneChange(params).then(res => {
        if (res.code === 1) {
          this.form.authConfirmNumber = res.entity // 발송된 인증번호 넣어주기
          // 개발 환경
          // this.form.authNumber = this.form.authConfirmNumber
          // 발송후 핸드폰 번호칸은  readonly
          this.msg.send = '재전송'
          document.getElementById("userPhone").readOnly = true
          document.getElementById("block").disabled = false
          // 인증번호 타이머 시작 (세팅시간 3분)
          this.fnTimer()
          this.form.isRunning = true
          // 인증번호 발송을 다시 누를경우 초기화 시켜주기 (미개발)
          if (this.form.isRunning) clearTimeout(this.setTimer)
        } else if (res.code === -1012) {
          alert('이미 사용 중인 전화번호입니다.')
        }
      })
    },
    fnConfirmAuth: function () {
      // 인증번호 칸이 빈 값일 경우 리턴 false
      if (this.$Util.isEmpty(this.form.authNumber)) return false
      if (this.form.authNumber !== this.form.authConfirmNumber) {
        alert('인증번호가 일치하지 않습니다.')
        return false
      } else {
        alert('인증되었습니다.')
        document.getElementById("block").disabled = true
        this.fnStop()
        this.form.isRunning = false // 타이머 숨기기
        this.form.isAuth = true
      }
    },
    fnTimer: function () {
      this.fnStop()
      this.form.timer = setInterval(() => {
        this.form.timeCounter--
        if (this.form.timeCounter <= 0) {
          this.fnStop()
          alert('인증 번호가 만료되었습니다.\n다시 인증해주세요.')
        }
        let time = this.form.timeCounter / 60
        let min = parseInt(time)
        let sec = Math.round((time - min) * 60)
        this.form.count = this.pad(min, 2) + ':' + this.pad(sec, 2)
      }, 1000)
    },
    pad: function (n, width) {
      n = n + ''
      return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
    },
    fnStop: function () {
      clearInterval(this.form.timer)
      this.form.timeCounter = 180
      this.form.count = "03:00"
    }
  }
}
</script>

<style scoped></style>
